import { useHits } from "react-instantsearch";

import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { useResponsiveGridLayout } from "@tudigo-monorepo/core-tudigo-utils";

export const useStartedProjectsLayout = () => {
  const { hits } = useHits();
  const { itemsPerPage } = useResponsiveGridLayout();
  const splitIndex = itemsPerPage / 2;

  const startItems = hits.slice(0, splitIndex) as any as Project[];
  const remainingItems = hits.slice(
    splitIndex,
    itemsPerPage,
  ) as any as Project[];

  return { startItems, remainingItems };
};
